import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import List from '@material-ui/core/List';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import Slide from '@material-ui/core/Slide';
import TextField from '@material-ui/core/TextField';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import SaveIcon from '@material-ui/icons/Save';
import BlockIcon from '@material-ui/icons/Block';

import { KeyboardDatePicker as DatePicker } from '@material-ui/pickers';

import { currencyFormatter, setTimer } from '../../utils'


const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  alignCenter: {
    textAlign: 'center',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  appBar: {
    padding: theme.spacing(1),
  },
});


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class TempDisabilityEarningsDialog extends React.Component {
  constructor(props) {
    super(props);
    this.rowsPerPages = [7, 13, 26, 52];

    this.state = {
      period: 0, // 0=weekly, 1=biweekly, 2=monthly
      page: 0,
      rowsPerPage: this.rowsPerPages[0]
    };
  }

  // ----------------------- Events -----------------------
  onCancel = () => {
    this.props.onClose(0);
  };

  onSave = () => {
    this.props.onClose(1);
  };

  onDisable = () => {
    this.props.onClose(2);
  };

  onAdd = () => {
    let value = [ ...this.props.value ];

    let startDate, lastDate, wage;
    if (value.length > 0) {
      let last = value[value.length - 1];
      startDate = new Date(last.endDate.getTime());
      startDate.setDate(startDate.getDate() + 1);
      wage = last.wage;
    }
    else {
      let doi = this.props.dateOfInjury;
      startDate = new Date(doi.getFullYear() - 1, doi.getMonth(), doi.getDate());
      wage = currencyFormatter.format(0);
    }

    let endDate = new Date(startDate.getTime());
    switch (this.state.period) {
    case 0: // weekly
      endDate.setDate(endDate.getDate() + 6);
      break;
    case 1: // bi-weekly
      endDate.setDate(endDate.getDate() + 13);
      break;
    default: // monthly
      endDate.setDate(endDate.getDate() + 31);
      endDate.setDate(0);
      break;
    }

    let newValue = {
      startDate: startDate,
      endDate: endDate,
      wage: wage,
      isSelected: false
    };

    value.push(newValue);
    this.props.onValueChange(value);
  };

  onDelete = () => {
    let { page, rowsPerPage } = this.state;

    let value = this.props.value.filter(row => !row.isSelected);
    if (page * rowsPerPage >= value.length)
      this.setState({ page: 0 });
    this.props.onValueChange(value);
  };

  onWageChanging = (index, wage) => {
    let value = [ ...this.props.value ];
    let { page, rowsPerPage } = this.state;
    value[page*rowsPerPage + index].wage = wage;
    this.props.onValueChange(value);
  };

  onWageChanged = (index, wage) => {
    let aww = currencyFormatter.parse(wage);
    if (aww == NaN || aww < 0)
      aww = 0;

    let value = [ ...this.props.value ];
    let { page, rowsPerPage } = this.state;
    value[page*rowsPerPage + index].wage = currencyFormatter.format(aww);
    this.props.onValueChange(value);
  };

  onStartDateChanged = (index, date) => {
    let value = [ ...this.props.value ];
    let { page, rowsPerPage } = this.state;
    value[page*rowsPerPage + index].startDate = date;
    this.props.onValueChange(value);
  };

  onEndDateChanged = (index, date) => {
    let value = [ ...this.props.value ];
    let { page, rowsPerPage } = this.state;
    value[page*rowsPerPage + index].endDate = date;
    this.props.onValueChange(value);
  };

  onRowSelected = (index, isSelected) => {
    let value = [ ...this.props.value ];
    let { page, rowsPerPage } = this.state;
    value[page*rowsPerPage + index].isSelected = isSelected;
    this.props.onValueChange(value);
  };

  onAllSelected = event => {
    let isSelected = event.target.checked;
    let value = [ ...this.props.value ];
    value.forEach(row => row.isSelected = isSelected );
    this.props.onValueChange(value);
  };

  onPeriodChanged = (period) => {
    this.setState({ period });
  };

  onPageChanged = (event, page) => {
    this.setState({ page });
  };

  onRowsPerPageChanged = event => {
    this.setState({
      page: 0,
      rowsPerPage: +event.target.value
    });
  };

  render() {
    const { isOpen, value, dateOfInjury, onValueChange, onClose, classes, ...other } = this.props;
    const { page, rowsPerPage } = this.state;

    let rowCount = value.length;
    let numSelected = 0;
    value.forEach(row => row.isSelected && numSelected++);

    return (
      <Dialog
        fullScreen
        scroll="paper"
        TransitionComponent={Transition}
        open={isOpen}
        onClose={this.onClose}
        aria-labelledby="confirmation-dialog-title"
        {...other}
      >
        <AppBar position="static" className={classes.appBar}>
          <Toolbar>
            <Tooltip title="Close without saving" aria-label="Close">
              <IconButton edge="start" color="inherit" onClick={this.onCancel} aria-label="closeButton">
                <CloseIcon />
              </IconButton>
            </Tooltip>
            <Typography variant="h6" className={classes.title}>
              Manually input work periods and wages
            </Typography>
            <Tooltip title="Add period and wage" aria-label="Add">
              <IconButton style={{ marginRight: 16 }} color="inherit" onClick={this.onAdd} aria-label="addButton">
                <AddIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete selected periods" aria-label="Delete">
              <span>
                <IconButton
                  disabled={ numSelected == 0 }
                  style={{ marginRight: 32 }}
                  color="inherit"
                  onClick={ this.onDelete }
                  aria-label="deleteButton"
                >
                  <DeleteIcon />
                </IconButton>
              </span>
            </Tooltip>
            <Tooltip title="Save manual input but disable it" aria-label="Disable">
              <IconButton color="inherit" onClick={this.onDisable} aria-label="disableButton">
                <BlockIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Save and close" aria-label="Save">
              <IconButton color="inherit" onClick={this.onSave} aria-label="saveButton">
                <SaveIcon />
              </IconButton>
            </Tooltip>
          </Toolbar>
        </AppBar>

        <Paper className={classes.paper}>
          <div style={{ width: '100%', textAlign: 'center' }}>
            <FormControl className={classes.alignCenter}>
              <FormLabel component="legend">Default wage period</FormLabel>
              <Select
                variant="outlined"
                value={ this.state.period }
                onChange={ e => this.onPeriodChanged(e.target.value) }
                input={<Input id="period" name="period" />}
                autoWidth
              >
                <MenuItem dense key='0' value={0}>Weekly</MenuItem>
                <MenuItem dense key='1' value={1}>Bi-weekly</MenuItem>
                <MenuItem dense key='2' value={2}>Monthly</MenuItem>
              </Select>
            </FormControl>
          </div>

          <TableContainer className={classes.container}>
            <Table stickyHeader size="small" aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell>
                    <Checkbox
                      indeterminate={ rowCount == 0 || (numSelected > 0 && numSelected != rowCount) }
                      checked={ numSelected == rowCount }
                      onChange={ this.onAllSelected }
                      inputProps={{ 'aria-label': 'select all' }}
                    />
                  </TableCell>
                  <TableCell align="center">
                    Start date
                  </TableCell>
                  <TableCell align="center">
                    End date
                  </TableCell>
                  <TableCell align="center">
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                { value.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map( (row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`;

                  // onClick={ event => this.onRowSelected(index, !row.isSelected) }
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={ row.isSelected || false }
                      tabIndex={ -1 }
                      key={ index }
                      selected={ row.isSelected || false }
                    >
                      <TableCell>
                        <Checkbox
                          checked={ row.isSelected || false }
                          onChange={ event => this.onRowSelected(index, event.target.checked) }
                          inputProps={{ 'aria-labelledby': labelId }}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <DatePicker
                          value={ row.startDate }
                          onChange={ (date, e) => this.onStartDateChanged(index, date) }
                          format={ 'MM/dd/yyyy' }
                        />
                      </TableCell>
                      <TableCell align="center">
                        <DatePicker
                          value={ row.endDate }
                          onChange={ (date, e) => this.onEndDateChanged(index, date) }
                          format={ 'MM/dd/yyyy' }
                        />
                      </TableCell>
                      <TableCell align="center">
                        <FormControl>
                          <TextField
                            margin="dense"
                            value={ row.wage }
                            onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                            onChange={ (e) => this.onWageChanging(index, e.target.value) }
                            onFocus={ (e) => e.target.select() }
                            onBlur={ (e) => this.onWageChanged(index, e.target.value) }
                            className={ classes.textField }
                          />
                        </FormControl>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={this.rowsPerPages}
            component="div"
            count={this.props.value.length}
            rowsPerPage={this.state.rowsPerPage}
            page={this.state.page}
            onPageChange={this.onPageChanged}
            onRowsPerPageChange={this.onRowsPerPageChanged}
          />
        </Paper>
      </Dialog>
    );
  }
};

TempDisabilityEarningsDialog.defaultProps = {
};

TempDisabilityEarningsDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  dateOfInjury: PropTypes.instanceOf(Date).isRequired,
  value: PropTypes.array.isRequired,
  onValueChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default withStyles(styles)(TempDisabilityEarningsDialog);
